import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  image: {
    textAlign: "center",
  },
  bienvenida: {
    width: "100%",
  },
  TituloLogeo: {
    fontSize: "5vh",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    marginTop: theme.spacing(20),
    marginBottom: theme.spacing(2),
  },
  SubtituloLogeo: {
    fontSize: "2vh",
    fontFamily: "Montserrat",
    fontWeight: "regular",
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(2),
  },
  Titulo: {
    fontSize: "5vh",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    paddingTop: theme.spacing(20),
    marginLeft: "-20%",
    paddingBottom: theme.spacing(8),
  },
  subTitulo: {
    fontSize: "1.5vh",
    fontFamily: "Montserrat",
    fontWeight: "regular",
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(4),
  },
  textLabel: {
    "$:focus": {
      color: "green",
    },
    swaltoast: {
      zIndex: "12000",
    },
  },
}));
